module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Arrow_down_Black.acda5484.svg";